import { takeLatest, put, call, fork } from "redux-saga/effects";

import {
    createdFinancialYear,
    failedCreateFinancialYear,
    fetchedFinancialYears,
    failedFetchFinancialYears,
    fetchedFinancials,
    failedFetchFinancials,
    updatedFinancials,
    failedUpdateFinancials
} from "store/actions";
import { message } from "antd";
import FinancialService from "services/financials-service";

import { FINANCIALS_ACTIONS } from "constants/actions";

function* createFinancialYear({ payload: { companyId, yearName } }) {
    try {
        const { data, error } = yield call(
            FinancialService.createFinancialYear,
            companyId,
            yearName
        );
        if (!error) {
            yield put(createdFinancialYear(companyId, yearName, data));
        } else {
            yield put(failedCreateFinancialYear(companyId, yearName, error));
            message.error("Failed to fetch financial year");
        }
    } catch(error) {
        yield put(failedCreateFinancialYear(companyId, yearName, error));
        message.error("Failed to fetch financial year");
    }
}

function* fetchFinancialYears({ payload: { companyId } }) {
    try {
        const { data, error } = yield call(
            FinancialService.fetchFinancialYears,
            companyId
        );
        if (!error) {
            yield put(fetchedFinancialYears(companyId, data));
        } else {
            yield put(failedFetchFinancialYears(companyId, error));
        }
    } catch(error) {
        yield put(failedFetchFinancialYears(companyId, error));
    }
}

function* fetchFinancials({ payload: { companyId } }) {
    try {
        const { data, error } = yield call(
            FinancialService.fetchFinancials,
            companyId
        );
        if (!error) {
            yield put(fetchedFinancials(companyId, data));
        } else {
            yield put(failedFetchFinancials(companyId, error));
        }
    } catch(error) {
        yield put(failedFetchFinancials(companyId, error));
    }
}

function* updateFinancials({ payload: { companyId, financialRecords } }) {
    try {
        const { data, error } = yield call(
            FinancialService.updateFinancials,
            companyId,
            financialRecords.map(_ => _.set("financial_year", _.financial_year.id))
        );
        if (!error) {
            yield put(updatedFinancials(companyId, data));
        } else {
            yield put(failedUpdateFinancials(companyId, error));
        }
    } catch(error) {
        message("Failed to update Company Financials");
        yield put(failedUpdateFinancials(companyId, error));
    }
}

export default fork(function*() {
    yield takeLatest(
        FINANCIALS_ACTIONS.CREATE_FINANCIAL_YEAR,
        createFinancialYear
    );
    yield takeLatest(
        FINANCIALS_ACTIONS.FETCH_FINANCIAL_YEARS,
        fetchFinancialYears
    );
    yield takeLatest(FINANCIALS_ACTIONS.FETCH_FINANCIALS, fetchFinancials);
    yield takeLatest(FINANCIALS_ACTIONS.UPDATE_FINANCIALS, updateFinancials);
});
